export default "__VITE_ASSET__bYk6BqGA__"